import {Map} from 'immutable'
import types from '../types/deposit'

const initialRoot = Map({
  isOpen: false,
  flowStep: '',
  flowReset: true,
  flowLoading: false,
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_OPEN:
      return state.set('isOpen', action.payload.isOpen)
    case types.START:
      return state.merge({isOpen: true, flowStep: '', flowReset: true})
    case types.SET_FLOW_STEP:
      return state.set('flowStep', action.payload.flowStep)
    case types.SET_FLOW_RESET:
      return state.set('flowReset', action.payload.flowReset)
    case types.SET_FLOW_LOADING:
      return state.set('flowLoading', action.payload.flowLoading)
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/depositV2/reducers/deposit.js